<template>
  <ion-app id="app">
    <ion-split-pane when="false">
      <ion-menu name="menu" type="overlay">
        <menu-module></menu-module>
      </ion-menu>

      <div class="ion-page" main>
        <ion-header class="mobile-ion-header" ref="nav" mode="ios" no-border>
          <header-module></header-module>
        </ion-header>
        <ion-content overflow-scroll="true" main ref="ionContent" :class="settingStyle">
          <router-view />
        </ion-content>
      </div>
    </ion-split-pane>
  </ion-app>
</template>

<script>
import Header from "./Header";
import Menu from "./Menu";
import debounce from "debounce";

export default {
  methods: {
    handleScroll(event) {
      // Any code to be executed when the window is scrolled
      const scrollAmnt = event.detail.currentY - event.detail.startY;
      if(scrollAmnt > 0) {
        const nav = this.$refs['nav'];
        nav.style.overflow = 'hidden';
        nav.style.height = '0px';

      } else {
        const nav = this.$refs['nav'];
        nav.style.removeProperty('height');
      }
    },
    whichTransitionEvent(el) {
      var t;
      var transitions = {
        'transition':'transitionend',
        'OTransition':'oTransitionEnd',
        'MozTransition':'transitionend',
        'WebkitTransition':'webkitTransitionEnd'
      }

      for(t in transitions){
          if( el.style[t] !== undefined ){
              return transitions[t];
          }
      }
    }
  },

  computed: {
    settingStyle() {
      return [
        "mode-" +
          (this.$store.state.settings.settings.theme || "normal"),
          "hydrated",
          "main"
      ];
    }
  },

   beforeDestroy() {
    // I switched the example from `destroyed` to `beforeDestroy`
    // to exercise your mind a bit. This lifecycle method works too.
    const debouncedHandeScroll = debounce(this.handleScroll, 50);
    const ionContent = this.$refs['ionContent'];
    ionContent.scrollEvents = false;
    ionContent.removeEventListener('ionScroll', (evt) => {debouncedHandeScroll(evt)});

    /* Listen for a transition! */
    const el = this.$refs['nav'];
    var transitionEvent = this.whichTransitionEvent(el);
    transitionEvent && el.removeEventListener(transitionEvent, () => {
      if(el.style.overflow == "hidden" && !el.style.height) {
        el.style.overflow = "visible";
      }
    });
  },

  watch: {
    "$store.state.route.meta.headerCollapsible": function(n=false, o) {
      if(n) {
        const debouncedHandeScroll = debounce(this.handleScroll, 50);
        const ionContent = this.$refs['ionContent'];
        ionContent.scrollEvents = true;
        ionContent.addEventListener('ionScroll', (evt) => {debouncedHandeScroll(evt)});

        /* Listen for a transition! */
        const el = this.$refs['nav'];
        var transitionEvent = this.whichTransitionEvent(el);
        transitionEvent && el.addEventListener(transitionEvent, () => {
          if(el.style.overflow == "hidden" && !el.style.height) {
            el.style.overflow = "visible";
          }
        });

      } else {
        const debouncedHandeScroll = debounce(this.handleScroll, 75);
        const ionContent = this.$refs['ionContent'];
        ionContent.scrollEvents = false;
        ionContent.removeEventListener('ionScroll', (evt) => {debouncedHandeScroll(evt)});

        /* Listen for a transition! */
        const el = this.$refs['nav'];
        var transitionEvent = this.whichTransitionEvent(el);
        transitionEvent && el.removeEventListener(transitionEvent, () => {
          if(el.style.overflow == "hidden" && !el.style.height) {
            el.style.overflow = "visible";
          }
        });
      }
    }
  },

  components: {
    "menu-module": Menu,
    "header-module": Header
  }
};
</script>

<style scoped>
  .split-pane-md.split-pane-visible > .split-pane-side {
    max-width: 280px !important;
    min-width: 280px !important;
  }

  .mobile-ion-header {
    transition: height 0.15s ease-in-out;
    height: 56px;
  }
</style>
